<div class="contentMain">
    <!-- breadcrumb -->
    <div class="row">
        <div class="col-md-12 mainheader header-container">
            <h5>Deliveries Entry - New Mode</h5>
        </div>
    </div>
    <!--/ breadcrumb-->
    <!-- main body -->
    <main class="row">
        <!-- card -->
        <div class="card">
            <!-- card body -->
            <div class="card-body">
                <!-- top row -->
                <div class="row">
                    <!-- col -->
                    <div class="col-md-6">
                        <div class="border p-3 h-100">
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Division</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Transaction</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Bill Cancel</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Date Range</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <!--/ col -->
                            </div>
                        </div>
                    </div>
                    <!--/ col -->
                    <!-- right col -->
                    <div class="col-md-6">
                        <div class="border p-3 h-100">
                            <div class="row">
                                <!-- col -->
                                <div class="col-md-12">
                                    
                                        <div class="form-group">
                                            <label>Branch</label>
                                            <select class="form-control show-tick ms select2" data-placeholder="Select">
                                                <option>Select </option>
                                                <option>Select Item1</option>
                                                <option>Select Item2</option>
                                                <option>Select Item3</option>
                                                <option>Select Item4</option>
                                            </select>
                                        </div>
                                    
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>INV No</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>UP To</label>
                                        <select class="form-control show-tick ms select2" data-placeholder="Select">
                                            <option>Select </option>
                                            <option>Select Item1</option>
                                            <option>Select Item2</option>
                                            <option>Select Item3</option>
                                            <option>Select Item4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    
                                    <div class="form-group">
                                        <label>Mobile No</label>
                                        <input type="text" class="form-control" placeholder="Order Number">
                                    </div>
                                
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="radio inlineblock m-r-10">
                                    <input type="radio" name="pack" id="Cash" class="with-gap" value="option1">
                                    <label for="Cash" class="pt-1">Cash</label>
                                </div>
                                <div class="radio inlineblock m-r-10">
                                    <input type="radio" name="pack" id="Credit" class="with-gap" value="option2" checked="">
                                    <label for="Credit" class="pt-1">Credit</label>
                                </div>
                                <div class="radio inlineblock m-r-10">
                                    <input type="radio" name="pack" id="Finance" class="with-gap" value="option2" checked="">
                                    <label for="Finance" class="pt-1">Card / Finance</label>
                                </div>
                                <div class="radio inlineblock m-r-10">
                                    <input type="radio" name="pack" id="UPI" class="with-gap" value="option2" checked="">
                                    <label for="UPI" class="pt-1">Both</label>
                                </div>
                            </div>
                                <!--/ col -->
                                <!-- col -->
                                <!--/ col -->
                                <!-- col -->
                                <!-- <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Account Name, Address-1, Address-2, Town, Phone, Mobile, Email</label>
                                        <textarea class="form-control" style="height:100px;"></textarea>
                                    </div>
                                </div> -->
                                <!--/ col -->
                            </div>
                        </div>
                    </div>
                    <!--/right  col -->
                </div>
                <br>
                <!--/ top row -->
                <!-- buttons row -->
                <!--/ buttons row -->
                <!-- right table -->
                <!-- <div class="border p-3 h-100" >
                   
                    <h4>Shirt Size &amp; Value</h4>
                    <div class="row" *ngIf="isShown" >
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Length</label>
                                <input type="text" class="form-control" placeholder="Length">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Chest</label>
                                <input type="text" class="form-control" placeholder="Chest">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Body</label>
                                <input type="text" class="form-control" placeholder="Body">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Hip</label>
                                <input type="text" class="form-control" placeholder="Hip">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Shoulder</label>
                                <input type="text" class="form-control" placeholder="Shoulder">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Calour</label>
                                <input type="text" class="form-control" placeholder="Calour">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Full hand</label>
                                <input type="text" class="form-control" placeholder="Full hand">
                            </div>
                        </div> -->
                <!-- <div class="col-md-3">
                            <div class="form-group">
                                <label>Half hand</label>
                                <input type="text" class="form-control" placeholder="Half hand">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Model</label>
                                <input type="text" class="form-control" placeholder="Half hand"
                                    value="11/4B 8LSP 1HP">
                            </div>
                        </div>
                        <div class="col-md-3">
                            
                                <button class=" btn redbtn float-right" (click)="sizeShow()" type="button">Save Item</button>
                            
                        </div>
                        
                    </div> -->
                <!--/ new item row-->
                <div class=" table-responsive">
                    <table class="table table-bordered table-striped table-hover js-basic-example dataTable kliqtable">
                        <thead>
                            <tr>
                                <th><input id="remember_me" type="checkbox"></th>
                                <th>Order Date</th>
                                <th>Trail Date</th>
                                <th>Deliv Date</th>
                                <th>Item Name</th>
                                <th>ord Qty</th>
                                <th>deliv Qty</th>
                                <th>Bal Qty</th>
                                <th>Req Qty</th>
                                <th>Rate</th>
                                <th>Item Value</th>
                                <th>Add Size</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input id="remember_me" type="checkbox">
                                </td>
                                <td>06/03/2021 </td>
                                <td>06/03/2021 </td>
                                <td> 09/03/2021 </td>
                                <td> SHIRT </td>
                                <td>3.00</td>
                                <td>1.00 </td>
                                <td>3.00</td>
                                <td>3.00</td>
                                <td>500.00</td>
                                <td>70000.00</td>
                                <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem"> Size</button>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input id="remember_me" type="checkbox">
                                </td>
                                <td>06/03/2021 </td>
                                <td>06/03/2021 </td>
                                <td> 09/03/2021 </td>
                                <td> SHIRT </td>
                                <td>3.00</td>
                                <td>1.00 </td>
                                <td>3.00</td>
                                <td>3.00</td>
                                <td>500.00</td>
                                <td>700.00</td>
                                <!-- <td> <button class="btn redbtn" type="button" data-toggle="modal"
                                        data-target="#createNewItem">
                                        Size</button>
                                    </td> -->
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                            </tr>
                            <tr>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                                <td> &nbsp; </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!--/ right table -->
            <!-- final row -->
            <div class="row">
                <div class="col-md-3">
                    <div class="p-3 border h-100 mt-3 h-100">
                        <div class="form-group">
                            <label>SMS Message</label>
                            <textarea class="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="p-3 border mt-3 h-100">
                        <div class="row">
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Items </h6>
                                <p><b>1</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Qty </h6>
                                <p><b>1</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Total Amt </h6>
                                <p><b>500.00</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>Adv Amt </h6>
                                <p><b>-100.00</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6>discount Amt </h6>
                                <p><b>-100.00</b></p>
                            </div>
                            <div class="col-md-2 col-sm-4">
                                <h6> Bill Amount </h6>
                                <p><b>300.00</b></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--/final row -->
        </div>
        <div class="modal fade" id="createNewItem" tabindex="-1" role="dialog">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="title" id="largeModalLabel">Shirt Size &amp; Value</h4>
                    </div>
                    <div class="modal-body border h-30">
                        <form>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Length<input type="text" class="form-control"
                                                placeholder="Length"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Chest <input type="text" class="form-control"
                                                placeholder="Chest"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Body <input type="text" class="form-control" placeholder="Body"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Hip <input type="text" class="form-control" placeholder="Hip"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Shoulder <input type="text" class="form-control"
                                                placeholder="Shoulder"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Calour <input type="text" class="form-control"
                                                placeholder="Calour"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Full hand <input type="text" class="form-control"
                                                placeholder="Full hand"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Half hand <input type="text" class="form-control"
                                                placeholder="Half hand"></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Model <input type="text" class="form-control" placeholder="Half hand"
                                                value="11/4B 8LSP 1HP"></label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default btn-round waves-effect">SAVE CHANGES</button>
                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">CLOSE</button>
                    </div>
                </div>
            </div>
        </div>
        <!--/ card body -->
        <div class="card-footer text-left w-100">
            <button class="btn redbtn" type="button">Customer</button>
            <button class="btn redbtn" type="button">Settlement</button>
            <button class="btn redbtn" type="button">Save</button>
            <button class="btn redbtn" type="button">Save & Print</button>
            <button class="btn redbtn" type="button">Refresh</button>
            <button class="btn redbtn" type="button">Close</button>
            <button class="btn redbtn" type="button">Save</button>
        </div>
        <!-- </div> -->
        <!--/ card -->
    </main>
    <!-- main body -->
</div>